import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import WysiwygOutlinedIcon from "@mui/icons-material/WysiwygOutlined";
import FolderCopyOutlinedIcon from "@mui/icons-material/FolderCopyOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import LegendToggleIcon from '@mui/icons-material/LegendToggle';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import FolderOffOutlinedIcon from '@mui/icons-material/FolderOffOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ContentPasteOffOutlinedIcon from '@mui/icons-material/ContentPasteOffOutlined';
import LibraryAddOutlinedIcon from '@mui/icons-material/LibraryAddOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import PowerSettingsNewOutlinedIcon from '@mui/icons-material/PowerSettingsNewOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop';
import SearchIcon from '@mui/icons-material/Search';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import UploadOutlinedIcon from '@mui/icons-material/Upload';
import SummarizeOutlinedIcon from '@mui/icons-material/Summarize';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTree';
import AnalyticsOutlinedIcon from '@mui/icons-material/Analytics';
import CandlestickChartOutlinedIcon from '@mui/icons-material/CandlestickChartOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import AddBoxIcon from '@mui/icons-material/AddBox';
import RemoveIcon from '@mui/icons-material/Remove';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
export {
    AccountTreeOutlinedIcon,
    CandlestickChartOutlinedIcon,
    AnalyticsOutlinedIcon,
    UploadOutlinedIcon,
    SummarizeOutlinedIcon,
    ExpandMoreIcon,
    ExpandLessIcon,
    HelpCenterOutlinedIcon,
    SettingsOutlinedIcon,
    SyncIcon,
    FolderCopyOutlinedIcon,
    WysiwygOutlinedIcon,
    MailOutlinedIcon,
    PersonOutlineIcon,
    GridViewOutlinedIcon,
    MarkEmailReadOutlinedIcon,
    DraftsOutlinedIcon,
    MarkEmailUnreadOutlinedIcon,
    UnsubscribeOutlinedIcon,
    ListAltOutlinedIcon,
    ForwardToInboxOutlinedIcon,
    AddOutlinedIcon,
    EditOutlinedIcon,
    DeleteOutlineOutlinedIcon,
    FileDownloadOutlinedIcon,
    EmailOutlinedIcon,
    PauseOutlinedIcon,
    LegendToggleIcon,
    TuneOutlinedIcon,
    CommentOutlinedIcon,
    UpdateOutlinedIcon,
    TaskAltOutlinedIcon,
    SaveOutlinedIcon,
    PublishedWithChangesOutlinedIcon,
    NoteAddOutlinedIcon,
    FolderOffOutlinedIcon,
    ErrorOutlineOutlinedIcon,
    ContentPasteOffOutlinedIcon,
    LibraryAddOutlinedIcon,
    VisibilityOffOutlinedIcon,
    VisibilityOutlinedIcon,
    MoreVertOutlinedIcon,
    PowerSettingsNewOutlinedIcon,
    LockOutlinedIcon,
    HourglassBottomOutlinedIcon,
    PlayCircleFilledWhiteOutlinedIcon,
    CallOutlinedIcon,
    ExpandLessOutlinedIcon,
    ExpandMoreOutlinedIcon,
    ChevronRightOutlinedIcon,
    AutorenewOutlinedIcon,
    AccessTimeOutlinedIcon,
    SwapHorizIcon,
    CloseOutlinedIcon,
    BorderColorOutlinedIcon,
    NotificationsOutlinedIcon,
    ModeEditOutlineOutlinedIcon,
    LocalShippingOutlinedIcon,
    ScreenSearchDesktopIcon,
    SearchIcon,
    SentimentVeryDissatisfiedIcon,
    KeyboardArrowDownIcon,
    KeyboardArrowUpIcon,
    RefreshIcon,
    PersonAddIcon,
    PersonRemoveIcon,
    AddBoxIcon,
    RemoveIcon,
    CheckCircleSharpIcon,
    ArrowBackIcon,
    ArrowForwardIcon
}
